import Intercom from "@intercom/messenger-js-sdk";
import { authResponse } from "Utils/authentication";

export default function installIntercomChat() {
  authResponse.promise.then((response) => {
    const { account } = response;
    if (!account) return;

    // Toggle the 2 sets of lines to switch between Intercom and intercom for Salesforce.
    // === Intercom:
    const app_id = "rmlzvihr";
    const messengerToken = account.intercom_messenger_token;
    const accountToken = account.intercom_account_token;
    // === Intercom for Salesforce:
    // const app_id = "os15edtq";
    // const messengerToken = account.intercom_for_salesforce_messenger_token;
    // const accountToken = account.intercom_for_salesforce_account_token;

    Intercom({
      app_id,
      user_id: account.id,
      name: account.first_name,
      email: account.email,
      intercom_user_jwt: messengerToken ?? undefined,
    });

    if (accountToken) {
      window.Intercom?.("setAuthTokens", {
        si_account_token: accountToken,
      });
    }
  });
}
